const constants = {
  DATE_FORMAT: 'DD-MMM, HH:mm',
  DATE_FORMAT_NO_TIME: 'DD-MMM-YY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  THREE_MONTH: 'THREE_MONTH',
  CUSTOME_RANGE: 'CUSTOME',
  month: {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec',
  },
  tonType: {
    '32_feet_mxl_container': { ton: 15, name: '32FT MXL', primary_group_id: 1 },
    '32_feet_sxl_container': { ton: 7, name: '32FT SXL', primary_group_id: 2 },
    '20-24_feet_container': { ton: 6, name: '20-24 FT CTR', primary_group_id: 3 },
    '17-24_feet_open': { ton: 6, name: '17-24 FT OPEN', primary_group_id: 4 },
    '10_wheel_open': { ton: 19, name: '10 Whl OPEN', primary_group_id: 5 },
    '12_wheel_open': { ton: 25, name: '12 Whl OPEN', primary_group_id: 6 },
    '14_wheel_open': { ton: 30, name: '14 Whl OPEN', primary_group_id: 7 },
  },
  ratePerTonTruckTypes: [7, 18, 33],
  POD_TYPE: {
    SOFT_POD: "SOFT POD",
    NO_POD: "NO POD"
}
};

export default constants;
